import { AiOutlineClose } from "react-icons/ai"
import { Body, BodyColor, BodyType, Button, ButtonTheme, ButtonVariant, Heading, InfoPanel, Search, TypographyColor, TypographyType } from "../../ui-elements";
import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { brandList, dropdownList, selectedBrands, selPOICategories } from "../../states";
import * as Constants from '../../utils/constants/Constants';


interface WatchListProps {
    isOpen: boolean;
    handleListOpen: (keyName: string, tagName?: string) => void;
    brandCheckBoxRef: React.RefObject<HTMLDivElement>;
    brandButtonRef: React.RefObject<HTMLDivElement>;
    style: React.CSSProperties;
}

export const BrandWatchList: React.FC<WatchListProps> = ({ isOpen, handleListOpen, brandCheckBoxRef, brandButtonRef, style }) => {
    const selCategoryList = useRecoilValue(selPOICategories);
    const geoGropdownList = useRecoilValue(dropdownList);
    const { brands } = useRecoilValue(brandList);
    const [filteredBrands, setFilteredBrands] = useState(brands);
    const [selBrands, setSelBrands] = useRecoilState(selectedBrands);
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [selTempBrands, setSelTempBrands] = useState<any[]>(selBrands || []);

    const handleInputChange = (value: string) => {
        setSearchTerm(value);
    };

    const handleSelectAll = () => {
        setSelTempBrands((prev: any) => {
            const isAllFilteredSelected = filteredBrands.every((company) =>
                prev.some((selected: any) => selected.companyName === company.companyName)
            );

            if (isAllFilteredSelected) {
                return prev.filter((item: any) => !filteredBrands.some(fb => fb.companyName === item.companyName));
            } else {
                return [...prev, ...filteredBrands.filter(fb => !prev.some((p: any) => p.companyName === fb.companyName))];
            }
        });
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.stopPropagation();
        const { value, checked } = event.target;
        if (checked) {
            setSelTempBrands([...selTempBrands, filteredBrands?.find(item => item.companyName === value)]);
        } else {
            setSelTempBrands(selTempBrands?.filter(item => item.companyName !== value) || []);
        }
    }

    const handleClearCurrentFilter = () => {
        setSelTempBrands((prev: any) => (prev.filter((item: any) => !filteredBrands.some(fb => fb.companyName === item.companyName))));
    }

    const handleClearFilter = () => {
        setSelTempBrands([]);
    }

    const handleCancelFilter = () => {
        setSelTempBrands(selBrands);
        handleListOpen('brands');
    }

    const handleApplyFilter = () => {
        setSelBrands(selTempBrands);
        handleListOpen('brands');
    }

    useEffect(() => {
        setFilteredBrands(brands || []);
        setSelBrands([]);
        setSelTempBrands([]);
    }, [brands]);

    useEffect(() => {
        if (!searchTerm) return setFilteredBrands(brands);
        return setFilteredBrands(brands?.filter((item) =>
            item.companyName.toLowerCase().includes(searchTerm.toLowerCase()))
        );
    }, [searchTerm]);

    const isCatsEqual = () => {
        return JSON.stringify(geoGropdownList.sub_districts?.cat) === JSON.stringify(selCategoryList);
    }

    useEffect(() => {
        if (!isOpen) {
            setSelTempBrands([...selBrands]);
        }
    }, [isOpen]);

    return (
        <div ref={brandCheckBoxRef} className="m-0 p-0 position-relative col-12">
            <div
                ref={brandButtonRef}
                className={`d-flex justify-content-between align-items-center cursor-pointer padding-top-bottom-1 poi-category`}
                onClick={(event) => { handleListOpen('brands', (event.target as HTMLElement).tagName); setSearchTerm(''); }}
            >
                <div className="d-flex justify-content-start align-items-center gap-1 col-11">
                    <span className="presence-indicator-hover-card highlighted-poi-indicator"></span>
                    {/* <Heading
                        title={`Highlight PoI (${selBrands?.length.toString().padStart(2, "0")}/${brands?.length.toString().padStart(2, "0")})`}
                        type={TypographyType.h6}
                        colour={TypographyColor.secondary}
                    /> */}
                    <Body
                        type={BodyType.p3}
                        color={BodyColor.secondary}
                        classname=""
                    >
                       {/* {`Highlight PoIs (${selBrands?.length.toString().padStart(2, "0")}/${brands?.length.toString().padStart(2, "0")})`} */}
                       {'Highlight PoIs'}
                    </Body>
                    {/* <InfoPanel text={Constants.iButtonText.homePage.leftPanel.brandLens} classname='icon-gray-0 fs-16 margin-left-2' /> */}
                </div>
                <span className="material-symbols-outlined fs-18 fw-bold icon-gray-0 p-0">keyboard_arrow_right</span>
            </div>
            {isOpen &&
                <div className='poi-category-list-home padding-top-bottom-4' style={style}>
                    <div className="d-flex justify-content-between align-items-center border-bottom padding-bottom-3 padding-left-right-5">
                        <Body
                            type={BodyType.p2}
                            color={BodyColor.secondary}
                            classname="p-0"
                        >
                            Highlight specific PoI
                        </Body>
                        <AiOutlineClose className="fs-12 text-black cursor-pointer" onClick={handleCancelFilter} />
                    </div>
                    <div className="padding-left-right-5 w-100">
                        <Search
                            handleInputChange={handleInputChange}
                            searchTerm={searchTerm}
                            hideSuggestionBox={true}
                            placeholderValue='Search by keyword'
                            classname='map-filters w-100 border-0 border-bottom rounded-0 fs-14'
                        />
                    </div>
                    <div className="padding-top-bottom-2 no-scrollbar brand-watchlist">
                        <div className='cursor-pointer padding-left-right-5 padding-top-bottom-3 poi-category'>
                            <div className="d-flex justify-content-between align-items-center p-0">
                                <div className="d-flex justify-content-start align-items-center p-0">
                                    <input
                                        className="p-0"
                                        type="checkbox"
                                        checked={filteredBrands.length > 0 && filteredBrands.every(fb =>
                                            selTempBrands.some(sb => sb.companyName === fb.companyName)
                                        )}
                                        onChange={handleSelectAll}
                                    />
                                    <Heading
                                        title={`Select all (${filteredBrands.length})`}
                                        type={TypographyType.h6}
                                        colour={TypographyColor.secondary}
                                        classname="p-0 padding-left-2"
                                    />
                                </div>
                                <Heading
                                    title='Clear'
                                    type={TypographyType.h6}
                                    colour={TypographyColor.secondary}
                                    classname="p-0 padding-left-2 text-underline"
                                    onClick={handleClearCurrentFilter}
                                />
                            </div>
                        </div>
                        {filteredBrands.map((category) => (
                            <div
                                key={category.companyName}
                                className={`cursor-pointer padding-left-right-5 padding-top-bottom-3 poi-category`}
                            >
                                <div className="d-flex justify-content-start align-items-center p-0">
                                    <input
                                        className="p-0"
                                        type="checkbox"
                                        value={category.companyName}
                                        checked={!!selTempBrands?.find(item => item.companyName === category.companyName)}
                                        onChange={(event) => handleChange(event)}
                                    />
                                    <Body
                                        type={BodyType.p3}
                                        color={BodyColor.secondary}
                                        classname="p-0 padding-left-2"
                                    >
                                        {`${category.companyName} (${category.branchCount})`}
                                    </Body>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="d-flex justify-content-around align-items-center padding-top-4 padding-bottom-1 border-top">
                        <Button
                            theme={ButtonTheme.primary}
                            variant={ButtonVariant.transparent}
                            type='button'
                            classname='padding-left-right-3'
                            // disabled={!selTempBrands?.length}
                            onClick={handleCancelFilter}
                        >
                            Cancel
                        </Button>
                        <Button
                            theme={ButtonTheme.primary}
                            variant={ButtonVariant.contained}
                            type='button'
                            classname='padding-left-right-5'
                            onClick={handleApplyFilter}
                        // disabled={!selTempBrands.length}
                        >
                            Apply
                        </Button>
                    </div>
                </div>
            }
        </div>
    )
}